import * as actionTypes from '../../constants/actionTypes';

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CLEAR_SCHEDULE_INFO:
      return action.payload;
    case actionTypes.UNLOAD_STATE:
      return initialState;
    case actionTypes.FETCH_REGION_ERROR:
    case actionTypes.FETCH_REGION_SUCCESS:
      if (action.payload.type === 'state') {
        return action.payload.region.map(data => {
          return {
            data,
            label: data,
            value: data,
          };
        });
      }
      return state;
    default:
      return state;
  }
}
